class TextStore {
    text = {};
}

let textStore = new TextStore();

function T(key) {          
    let value = textStore.text[key];    
    if (value) {
        //return '++' + key + '++';
        return value
    }     
    //return '!!' + key + '!!';
    return key;
}

export {
    textStore,
    T,
};


// WEBPACK FOOTER //
// ./src/stores/textStore.js